import Modal from "@/tpo/Modal";

/**
 * We really need a "Modal Manager" system like the react component library
 * mantine providers so we can ensure only one modal shows at a time.
 * As it stands these notification modals should ever show on top of
 * other modals.
 */

export default function NotificationModal({
  children,
  onClose,
  background,
  bg,
  borderRadius = [0, 0, 20],
  maxWidth = 1020
}) {
  return (
    <Modal
      mode={["fullScreen", "fullScreen", "centered"]}
      maxWidth={maxWidth}
      bg={bg}
      background={background}
      borderRadius={borderRadius}
      closeButton
      headerProps={{
        p: [20, 20, 40]
      }}
      show
      close={onClose}
      data-component-name="NotificationModal"
    >
      {children}
    </Modal>
  );
}

NotificationModal.defaultProps = {
  bg: "white"
};
